import { gql } from '@apollo/client';
export const UpdateLeaveTypeIsPaidMutation = gql `
    mutation UpdateLeaveTypeIsPaid($siteSetId: InstitutionSetId!, $leaveType: StaffLeaveType!, $isPaid: Boolean!) {
        staffhours {
            settings {
                updateLeaveTypeIsPaid(siteSetId: $siteSetId, leaveType: $leaveType, isPaid: $isPaid)
            }
        }
    }
`;
